import { useEffect, useRef } from 'react';
import exhibitions from "../../images/events/exhibitions.jpg";
import gsap from 'gsap';

export default function EventsSection() {
  const sectionRef = useRef(null);

  useEffect(() => {
    if (sectionRef.current) {
      gsap.fromTo(sectionRef.current,
        { y: 40, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.7, ease: 'power3.out' }
      );
    }
  }, []);

  return (
    <section ref={sectionRef} className="relative w-full h-[100vh] h-[100dvh] flex items-start justify-center overflow-hidden pt-32 md:pt-48">
      <div
        className="absolute inset-0 z-0 bg-cover"
        style={{
          backgroundImage: `url(${exhibitions})`,
          backgroundPosition: 'center 20%',
        }}
      >
        <div className="absolute inset-0 bg-slate-950/40" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center px-4">
        <h2 className="font-custom font-bold text-white md:text-8xl text-5xl">EXHIBITIONS</h2>
        <p className="md:text-3xl text-white text-2xl mt-8">Find out more about our team and what we do</p>
      </div>
    </section>
  );
}
